export const getTokenResult = {
  access_token:
    'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICItQTV2NFR1ODg1SnRqc1JkbVl6cDlsVFZWUEhKaXdPeFd5Slh6MTFOM3JzIn0.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.CAULI0vviDeNejyWY7ig1SSL2C8b59hb1BXpiHEmERrTV0UgsxI-i1b8vvtXy6ZBegYXP9418ogYi9gwblq99dEiqd5ee4DVj6l8PqubmsbD2GoT2agvkASf6v7rSYTX1H5g0uAQ4XuHVRWDUy0A-Ro2WbNFChB69V0lB_x5TYelwl0k_FT5BEL6PElFZ-5puXUQ8kgJXv2YeykvXeum8U12c3MW2zYebJfLtqP77RG72KtFzIJHubwnF4kM8lPMQBaxmjE0Ag35GVryprwSuAsMHjZoBKo64IwI1bX-Tfj9gn_nx5td7LLJ5ZPVBKwt7rQia5Fth2BlTpSYb1GK0w',
  expires_in: 1800,
  refresh_expires_in: 31535999,
  refresh_token:
    'eyJhbGciOiJIUzUxMiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICIxN2ZjNTczOC0xZGVlLTQzZWItOWE3ZC1kNzk2NTIzZTI3YWEifQ.eyJleHAiOjE3OTIwNDQ5OTQsImlhdCI6MTc2MDUwODk5NSwianRpIjoiNzAzNzI3OGEtYzVjMi04ZmMyLWUzMjAtNjlkZGM0ZjRhYjZjIiwiaXNzIjoiaHR0cHM6Ly9pZC5ldS50ZXN0LnRvbXJhLmNsb3VkL2F1dGgvcmVhbG1zL1RvbXJhQ29ubmVjdFVzZXJzIiwiYXVkIjoiaHR0cHM6Ly9pZC5ldS50ZXN0LnRvbXJhLmNsb3VkL2F1dGgvcmVhbG1zL1RvbXJhQ29ubmVjdFVzZXJzIiwic3ViIjoiZDQ1OTQwOTktZDdkZi00MzkzLThlYjEtODBiOWRjYjdkYTc4IiwidHlwIjoiUmVmcmVzaCIsImF6cCI6InZvdWNoZXItYWRtaW4tdWkiLCJzaWQiOiI1ZDIyZjUyZi01Zjc1LTQxOTQtOWFmNS1mZmUwMjNhYjM2NmUiLCJzY29wZSI6Im9wZW5pZCByb2xlcyBwcm9maWxlIGJhc2ljIHdlYi1vcmlnaW5zIGFjciBlbWFpbCJ9.zlYMHSx-FeYl-b-lclNQUt4FylNi9oP2e0MByKrTvBsQ2nnzTZTVrW4-HcrQaN50nlQITqUzL_rvy5jjkcFz4w',
  token_type: 'Bearer',
  id_token:
    'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICItQTV2NFR1ODg1SnRqc1JkbVl6cDlsVFZWUEhKaXdPeFd5Slh6MTFOM3JzIn0.eyJleHAiOjE3NjA1MTA3OTUsImlhdCI6MTc2MDUwODk5NSwiYXV0aF90aW1lIjoxNzYwNTA4OTk0LCJqdGkiOiJlNDkwNmNhOS0wOTA0LTJlYTQtZjgxYi1hMWUyNmExNWVjYjEiLCJpc3MiOiJodHRwczovL2lkLmV1LnRlc3QudG9tcmEuY2xvdWQvYXV0aC9yZWFsbXMvVG9tcmFDb25uZWN0VXNlcnMiLCJhdWQiOiJ2b3VjaGVyLWFkbWluLXVpIiwic3ViIjoiZDQ1OTQwOTktZDdkZi00MzkzLThlYjEtODBiOWRjYjdkYTc4IiwidHlwIjoiSUQiLCJhenAiOiJ2b3VjaGVyLWFkbWluLXVpIiwibm9uY2UiOiJwVnJaZVFQSGVUVUdTZTFjXzNHLVUiLCJzaWQiOiI1ZDIyZjUyZi01Zjc1LTQxOTQtOWFmNS1mZmUwMjNhYjM2NmUiLCJhdF9oYXNoIjoidTdhbkRmcWVBZ0pCR0tBTE9TbDlkdyIsImFjciI6IjEiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IkVsaW4gU3VuZGUgV2lsYmVyZyIsInByZWZlcnJlZF91c2VybmFtZSI6ImVsaW4uc3VuZGUud2lsYmVyZ0B0b21yYS5jb20iLCJnaXZlbl9uYW1lIjoiRWxpbiBTdW5kZSIsImZhbWlseV9uYW1lIjoiV2lsYmVyZyIsImVtYWlsIjoiZWxpbi5zdW5kZS53aWxiZXJnQHRvbXJhLmNvbSJ9.dZ7QzWQ3P4LfxXqmtueZ6gIEjbq-LjqyYsqAsXyH0hFz4QBTySguJtB1zsxdZNAru0HRNK8YgcqVNyBj69y7GwLNQubsJJIrA2SLap-dJ100L-lArACO4Dy3pXVMpgVRWFPXRn8-dpJ0HDjZ7sCwzVVQzGb6snfTpWILAJUoqdXbfAZ_OxyMP22495ybDDjnlAOpdSheG8hdfBHd0oCSrgRWQaGnOT57N2WN1myc_dIgE922YgHGKJGqcv8pLvuJ6Snm8lh2n7xEjFHpv_KGZI9PTEEpmXmTFST9h6Tf-bL4-S63idInjEXimcgsp-9Z_29K1bLOFQIf_O-gjQHTFw',
  'not-before-policy': 0,
  session_state: '5d22f52f-5f75-4194-9af5-ffe023ab366e',
  scope: 'openid profile email'
}

export const getSerialSearchResult = {
  data: [
    {
      barcode: '9803601052758828693500020979',
      organizationId: '7fe76f14-046e-3180-a26d-aa3a2247500a',
      organizationName: 'Woolworths',
      transactionTimestamp: '2020-04-30T22:49:15.352790Z',
      voucherState: 'NEW',
      consumerId: '936010527',
      consumerLocation: 'RVM',
      refundAmount: '0.200',
      rvmSerialNumber: '936010527',
      csTimestamp: '2020-04-30T22:48:55Z',
      csSource: 'RVM',
      csDigital: true,
      locationTimezone: 'Australia/Sydney',
      locationName: 'Woolworths Kiama'
    },
    {
      barcode: '9803601052758829047200390969',
      organizationId: '7fe76f14-046e-3180-a26d-aa3a2247500a',
      organizationName: 'Woolworths',
      transactionTimestamp: '2020-04-30T23:50:11.337609Z',
      voucherState: 'CONSUMED',
      consumerId: '936010526',
      consumerLocation: 'RVM',
      refundAmount: '3.900',
      rvmSerialNumber: '936010527',
      csTimestamp: '2020-04-30T23:47:52Z',
      csSource: 'RVM',
      csDigital: false,
      locationTimezone: 'Australia/Sydney',
      locationName: 'Woolworths Kiama'
    }
  ]
}

export const getBarcodeSearchResult = {
  data: [
    {
      barcode: '9803601052758978832200860056',
      organizationId: '7fe76f14-046e-3180-a26d-aa3a2247500a',
      organizationName: 'Woolworths',
      transactionTimestamp: '2020-05-18T07:55:45.796144Z',
      voucherState: 'NEW',
      consumerId: '936010527',
      consumerLocation: 'RVM',
      refundAmount: '8.600',
      rvmSerialNumber: '936010527',
      csTimestamp: '2020-05-18T07:52:02Z',
      csSource: 'RVM',
      csDigital: false,
      locationTimezone: 'Australia/Sydney',
      locationName: 'Woolworths Kiama'
    }
  ]
}

export const getVoucherTimelineResult = {
  data: {
    voucher: {
      barcode: '9803601045666579417101680753',
      organizationId: '7fe76f14-046e-3180-a26d-aa3a2247500a',
      organizationName: 'Woolworths',
      transactionTimestamp: '2022-10-15T00:47:59.239361Z',
      voucherState: 'CONSUMED',
      consumerId: '1204-013',
      consumerLocation: '1204',
      refundAmount: '16.800',
      rvmSerialNumber: '936010456',
      csTimestamp: '2022-10-15T00:36:11Z',
      csEndTimestamp: '2022-10-15T00:37:11Z',
      csSource: 'RVM',
      csDigital: false,
      locationTimezone: 'Australia/Sydney',
      locationName: 'Ingleburn Town Centre'
    },
    timeline: [
      {
        eventType: 'CREATED',
        timestamp: '2022-10-15T00:41:30.972455Z',
        state: 'NEW',
        source: 'RVM',
        createdBy: '936010456'
      },
      {
        eventType: 'REQUEST',
        timestamp: '2022-10-15T00:47:57.297612Z',
        requestType: 'VOUCHER_RESERVED',
        consumerId: '1204-013',
        internalResponse: 'SUCCESS',
        responseCode: 200,
        responseMessage: 'OK',
        durationMillis: 15,
        success: true
      },
      {
        eventType: 'STATE_UPDATE',
        timestamp: '2022-10-15T00:47:57.297612Z',
        state: 'RESERVED',
        reservedUntil: '2022-10-15T00:49:57.297612Z',
        consumerId: '1204-013'
      },
      {
        eventType: 'REQUEST',
        timestamp: '2022-10-15T00:47:59.239361Z',
        requestType: 'VOUCHER_CONSUMED',
        consumerId: '1204-013',
        internalResponse: 'SUCCESS',
        responseCode: 200,
        responseMessage: 'OK',
        durationMillis: 5,
        success: true
      },
      {
        eventType: 'STATE_UPDATE',
        timestamp: '2022-10-15T00:47:59.239361Z',
        state: 'CONSUMED',
        reservedUntil: null,
        consumerId: '1204-013'
      },
      {
        eventType: 'REQUEST',
        timestamp: '2022-10-15T00:48:02.908852Z',
        requestType: 'VOUCHER_RESERVED',
        consumerId: '1204-013',
        internalResponse: 'ALREADY_CONSUMED',
        responseCode: 403,
        responseMessage: 'Already consumed',
        durationMillis: 3,
        success: false
      },
      {
        eventType: 'REQUEST',
        timestamp: '2022-10-15T01:34:20.081367Z',
        requestType: 'VOUCHER_RESERVED',
        consumerId: '1204-088',
        internalResponse: 'ALREADY_CONSUMED',
        responseCode: 403,
        responseMessage: 'Already consumed',
        durationMillis: 3,
        success: false
      }
    ]
  }
}

export const getOrganizationsResult = {
  data: [
    { id: '4389f17d-1e98-3c51-aa45-da1bd2bf06cc', name: 'Coles' },
    { id: 'cad876fd-54dd-3805-8de6-f7c0f3137505', name: 'TOMRA NSW' }
  ]
}

export const getStatisticsResult = {
  data: [
    {
      storeName: 'IGA Deniliquin 1',
      machineSerialNumber: '936010139',
      digitalCount: 6,
      newCount: 87,
      reservedCount: 0,
      consumedCount: 0
    },
    {
      storeName: 'IGA Deniliquin 2',
      machineSerialNumber: '936010140',
      digitalCount: 3,
      newCount: 59,
      reservedCount: 0,
      consumedCount: 0
    }
  ]
}

export const getNewVoucherTimelineResult = {
  data: {
    voucher: {
      barcode: '9803601052758978832200860056',
      organizationId: 'b2a792dc-7ca9-4634-b718-3aef7c258f8b',
      organizationName: 'TOMRA NT 811500',
      transactionTimestamp: '2020-10-29T15:15:41.173134Z',
      voucherState: 'NEW',
      consumerId: 'device#1',
      consumerLocation: 'G4550',
      refundAmount: '0.200',
      rvmSerialNumber: '936012776',
      csTimestamp: '2020-10-29T08:22:28Z',
      csSource: 'RVM',
      csDigital: false,
      locationTimezone: 'Australia/Darwin',
      locationName: 'Tomra Recycling Centre Coconut Grove'
    },
    timeline: [
      {
        eventType: 'CREATED',
        timestamp: '2020-10-29T08:23:38.024389Z',
        state: 'NEW',
        source: 'RVM',
        createdBy: '936012776'
      }
    ]
  }
}

export const getReservedVoucherTimelineResult = {
  data: {
    voucher: {
      barcode: '9803601052758978832200860057',
      organizationId: 'b2a792dc-7ca9-4634-b718-3aef7c258f8b',
      organizationName: 'TOMRA NT 811500',
      transactionTimestamp: '2020-10-29T15:15:41.173134Z',
      voucherState: 'RESERVED',
      consumerId: 'device#1',
      consumerLocation: 'G4550',
      refundAmount: '0.200',
      rvmSerialNumber: '936012776',
      csTimestamp: '2020-10-29T08:22:28Z',
      csSource: 'RVM',
      csDigital: false,
      locationTimezone: 'Australia/Darwin',
      locationName: 'Tomra Recycling Centre Coconut Grove'
    },
    timeline: [
      {
        eventType: 'CREATED',
        timestamp: '2020-10-29T08:23:38.024389Z',
        state: 'NEW',
        source: 'RVM',
        createdBy: '936012776'
      }
    ]
  }
}

export const getTimelineBarcodeSearchResult = {
  data: [
    {
      barcode: '9803601052758978832200860057',
      organizationId: '7fe76f14-046e-3180-a26d-aa3a2247500a',
      organizationName: 'Woolworths',
      transactionTimestamp: '2020-05-18T07:55:45.796144Z',
      voucherState: 'NEW',
      consumerId: '936010527',
      consumerLocation: 'RVM',
      refundAmount: '8.600',
      rvmSerialNumber: '936010527',
      csTimestamp: '2020-05-18T07:52:02Z',
      csSource: 'RVM',
      csDigital: false,
      locationTimezone: 'Australia/Sydney',
      locationName: 'Woolworths Kiama'
    }
  ]
}

export const getVoucherTimelineBarcodeSearchResult = {
  data: {
    voucher: {
      barcode: '9803601052758978832200860057',
      organizationId: '7fe76f14-046e-3180-a26d-aa3a2247500a',
      organizationName: 'Woolworths',
      transactionTimestamp: '2020-05-18T07:55:45.796144Z',
      voucherState: 'NEW',
      consumerId: '936010527',
      consumerLocation: 'RVM',
      refundAmount: '8.600',
      rvmSerialNumber: '936010527',
      csTimestamp: '2020-05-18T07:52:02Z',
      csSource: 'RVM',
      csDigital: false,
      locationTimezone: 'Australia/Sydney',
      locationName: 'Woolworths Kiama'
    },
    timeline: [
      {
        eventType: 'CREATED',
        timestamp: '2020-10-29T08:23:38.024389Z',
        state: 'NEW',
        source: 'RVM',
        createdBy: '936012776'
      }
    ]
  }
}

export const getSoapUserResult = {
  data: [
    {
      organizationId: '7fe76f14-046e-3180-a26d-aa3a2247500a',
      organizationName: 'Woolworths',
      password: null,
      userName: 'tomraInternal'
    }
  ]
}

export const getSoapOrganizationResult = {
  data: [
    {
      id: 'cad876fd-54dd-3805-8de6-f7c0f3137505',
      name: 'TOMRA NSW'
    },
    {
      id: 'b102eb3d-3f08-4a9f-9dee-1505d24ac180',
      name: 'Coles'
    }
  ]
}

export const createSoapUserResult = {
  data: {
    userName: 'Ola Normann',
    password: null,
    organizationId: '20de4fbb-1554-3ba2-bd1e-79814773b9f7',
    organizationName: 'TOMRA NSW'
  }
}

export const soapUserDetailResult = {
  data: {
    userName: 'tomraInternal',
    password: 'tr67Yn12',
    organizationId: '4389f17d-1e98-3c51-aa45-da1bd2bf06cc',
    organizationName: 'Woolworths'
  }
}
